<template>
  <!-- 报销审批流程详情 -->
  <div class="bid-follow-process-detail">
    <div class="title">
      投标渠道成本和代垫退款申请审批进度（ {{details.Code}} ）
    </div>
    <div v-if="JSON.stringify(details) != '{}'">
      <sub-title title="退款信息"></sub-title>
      <div class="details-table">
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">
              退款类型：
            </div>
            <div class="item-right">
              {{details.Category===1 ? '渠道成本退款' : details.Category===2 ? '垫付退款' : ''}}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">
              退款金额：
            </div>
            <div class="item-right">
              {{$common.moneyFormat(details.RefundAmount)}}
            </div>
          </div>
        </div>
        <div class="details-box-item" v-if="details.Category===2">
          <div class="details-box-item">
            <div class="item-left">
              付款人：
            </div>
            <div class="item-right">
              {{details.ProxyPayerName}}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">
              付款金额：
            </div>
            <div class="item-right">
              {{$common.moneyFormat(details.ProxyPayAmount)}}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">
              付款日期：
            </div>
            <div class="item-right">
              {{$common.timesToTime(details.ProxyPayDate)}}
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">
              收款人：
            </div>
            <div class="item-right">
              {{details.PayeeName}}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">
              开户银行：
            </div>
            <div class="item-right">
              {{details.PayeeBankName}}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">
              银行账号：
            </div>
            <div class="item-right">
              {{details.PayeeBankAccount}}
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="item-left">
            备注：
          </div>
          <div class="item-right">
            {{details.ApplyRemark}}
          </div>
        </div>
      </div>
      <!-- 流程图 -->
      <flow-chart :details="details" :selTab="type" :TemplateID="TemplateID" @close="$emit('refresh')" v-if="JSON.stringify(details)!='{}'" />
    </div>

    <!-- 图片预览 -->
    <el-dialog title="图片预览" :visible.sync="dialogImgVisible" center>
      <div style="  display: flex;  justify-content: center; align-items: flex-start; max-height: 58vh;  overflow: auto; padding: 12px 0 24px 0; ">
        <img width="90%" :src="previewImgUrl" alt="" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { WorkflowQuery } from '@/http/api'
export default {
  name: 'SubstitutePaymentRefund',
  props: {
    ID: {       // 当前id
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: ""
    },
    TemplateID: {    // 流程ID
      type: Number,
      default: null
    }
  },
  data() {
    return {
      BASE_API: window.BASE_API,
      dialogImgVisible: false,
      previewImgUrl: "",
      details: {}
    }
  },
  watch: {
    ID: {
      handler(val, oldVal) {
        this.getDetails();
      },
      immediate: true
    }
  },
  methods: {
    getDetails() {
      this.$emit('loading', true)
      WorkflowQuery({ workflowId: this.ID, templateId: this.TemplateID }, 'Get').then(res => {
        if (!!res && JSON.stringify(res) != "{}") {
          this.details = res;
        };
        this.$emit('loading', false)
      })
    }
  },
}
</script>
<style lang="less" scoped>
@import "./details.less";
.details-box-item {
  .details-box-item:nth-of-type(2) {
    .item-left {
      width: 126px;
    }
  }
  .details-box-item:nth-of-type(3) {
    .item-left {
      width: 126px;
    }
  }
}
</style>